<div class="container">
  <gds-spacer classes="spacer-70"></gds-spacer>
  <!--Lost Found Confirmation Heading -->

  <gds-heading
    [data]="{
      heading: pageLabels?.['lostForm_conf.heading'],
    }"
    class="A3-W6"
  >
  </gds-heading>
  <gds-spacer classes="spacer-50"></gds-spacer>

  <!--Lost Found Confirmation Description -->
  <gds-heading
    [data]="{
      heading: pageLabels?.['lostForm_conf.desc'],
    }"
    class="A5-W4"
  >
  </gds-heading>
  <gds-spacer classes="spacer-70"></gds-spacer>

  <!--Lost Found Confirmation Details -->
  <hr class="hr-rule" />
  <gds-spacer classes="spacer-50"></gds-spacer>
  <gds-heading
    [data]="{
      heading: pageLabels?.['lostForm_conf.lastName'],
    }"
    class="B1-W4"
  >
  </gds-heading>
  <gds-spacer classes="spacer-50"></gds-spacer>
  <gds-heading
    [data]="{
      heading: lostFoundForm?.value?.lastName,
    }"
    class="A5-W5"
  >
  </gds-heading>
  <gds-spacer classes="spacer-50"></gds-spacer>

  <gds-heading
    [data]="{
      heading: pageLabels?.['lostForm_conf.lastName_furigana'],
    }"
    class="B1-W4"
  >
  </gds-heading>
  <gds-spacer classes="spacer-50"></gds-spacer>

  <gds-heading
    [data]="{
      heading: lostFoundForm?.value?.last_name_furgina,
    }"
    class="A5-W5 email-field"
  >
  </gds-heading>
  <gds-spacer classes="spacer-50"></gds-spacer>
  <hr class="hr-rule" />
  <gds-spacer classes="spacer-50"></gds-spacer>
  <gds-heading
    [data]="{
      heading: pageLabels?.['lostForm_conf.firstName'],
    }"
    class="B1-W4"
  >
  </gds-heading>
  <gds-spacer classes="spacer-50"></gds-spacer>
  <gds-heading
    [data]="{
      heading: lostFoundForm?.value?.firstName,
    }"
    class="A5-W5"
  >
  </gds-heading>
  <gds-spacer classes="spacer-50"></gds-spacer>

  <gds-heading
    [data]="{
      heading: pageLabels?.['lostForm_conf.firstName_furigana'],
    }"
    class="B1-W4"
  >
  </gds-heading>
  <gds-spacer classes="spacer-50"></gds-spacer>
  <gds-heading
    [data]="{
      heading: lostFoundForm?.value?.first_name_furgina,
    }"
    class="A5-W5"
  >
  </gds-heading>
  <gds-spacer classes="spacer-50"></gds-spacer>
  <hr class="hr-rule" />
  <gds-spacer classes="spacer-50"></gds-spacer>

  <gds-heading
    [data]="{
      heading: pageLabels?.['lostForm_conf.email_address'],
    }"
    class="B1-W4"
  >
  </gds-heading>
  <gds-spacer classes="spacer-50"></gds-spacer>
  <gds-heading
    [data]="{
      heading: lostFoundForm?.value?.email,
    }"
    class="A5-W5"
  >
  </gds-heading>
  <gds-spacer classes="spacer-50"></gds-spacer>
  <hr class="hr-rule" />
  <gds-spacer classes="spacer-50"></gds-spacer>

  <gds-heading
    [data]="{
      heading: pageLabels?.['lostForm_conf.phone'],
    }"
    class="B1-W4"
  >
  </gds-heading>
  <gds-spacer classes="spacer-50"></gds-spacer>
  <gds-heading
    [data]="{
      heading: lostFoundForm?.value?.phoneNumber,
    }"
    class="A5-W5"
  >
  </gds-heading>
  <gds-spacer classes="spacer-50"></gds-spacer>
  <hr class="hr-rule" />
  <gds-spacer classes="spacer-50"></gds-spacer>
  <gds-heading
    [data]="{
      heading: pageLabels?.['lostForm_conf.postalCode'],
    }"
    class="B1-W4"
  >
  </gds-heading>
  <gds-spacer classes="spacer-50"></gds-spacer>
  <gds-heading
    [data]="{
      heading: lostFoundForm?.value?.postalCode,
    }"
    class="A5-W5"
  >
  </gds-heading>
  <gds-spacer classes="spacer-50"></gds-spacer>
  <gds-heading
    [data]="{
      heading: pageLabels?.['lostForm_conf.prefecture'],
    }"
    class="B1-W4"
  >
  </gds-heading>
  <gds-spacer classes="spacer-50"></gds-spacer>
  <gds-heading
    [data]="{
      heading: lostFoundForm?.value?.prefecture,
    }"
    class="A5-W5"
  >
  </gds-heading>
  <gds-spacer classes="spacer-50"></gds-spacer>
  <gds-heading
    [data]="{
      heading: pageLabels?.['lostForm_conf.city'],
    }"
    class="B1-W4"
  >
  </gds-heading>
  <gds-spacer classes="spacer-50"></gds-spacer>
  <gds-heading
    [data]="{
      heading: lostFoundForm?.value?.city,
    }"
    class="A5-W5"
  >
  </gds-heading>
  <gds-spacer classes="spacer-50"></gds-spacer>
  <gds-heading
    [data]="{
      heading: pageLabels?.['lostForm_conf.town'],
    }"
    class="B1-W4"
  >
  </gds-heading>
  <gds-spacer classes="spacer-50"></gds-spacer>
  <gds-heading
    [data]="{
      heading: lostFoundForm?.value?.town,
    }"
    class="A5-W5"
  >
  </gds-heading>
  <gds-spacer classes="spacer-50"></gds-spacer>
  <gds-heading
    [data]="{
      heading: pageLabels?.['lostForm_conf.aptNo'],
    }"
    class="B1-W4"
  >
  </gds-heading>
  <gds-spacer classes="spacer-50"></gds-spacer>
  <gds-heading
    [data]="{
      heading: lostFoundForm?.value?.street,
    }"
    class="A5-W5"
  >
  </gds-heading>
  <gds-spacer classes="spacer-50"></gds-spacer>
  <hr class="hr-rule" />
  <gds-spacer classes="spacer-50"></gds-spacer>
  <gds-heading
    [data]="{
      heading: pageLabels?.['lostForm_conf.dateOfLoss'],
    }"
    class="B1-W4"
  >
  </gds-heading>
  <gds-spacer classes="spacer-50"></gds-spacer>
  <gds-heading
    [data]="{
      heading: formatShortDate(lostFoundForm?.value?.dob),
    }"
    class="A5-W5"
  >
  </gds-heading>
  <gds-spacer classes="spacer-50"></gds-spacer>
  <hr class="hr-rule" />
  <gds-spacer classes="spacer-50"></gds-spacer>
  <gds-heading
    [data]="{
      heading: pageLabels?.['lostForm_conf.lostTime'],
    }"
    class="B1-W4"
  >
  </gds-heading>
  <gds-spacer classes="spacer-50"></gds-spacer>
  <gds-heading
    [data]="{
      heading: lostFoundForm?.value?.lostTime,
    }"
    class="A5-W5"
  >
  </gds-heading>
  <gds-spacer classes="spacer-50"></gds-spacer>
  <hr class="hr-rule" />
  <gds-spacer classes="spacer-50"></gds-spacer>
  <gds-heading
    [data]="{
      heading: pageLabels?.['lostForm_conf.location'],
    }"
    class="B1-W4"
  >
  </gds-heading>
  <gds-spacer classes="spacer-50"></gds-spacer>
  <gds-heading
    [data]="{
      heading: lostFoundForm?.value?.lostLocation,
    }"
    class="A5-W5"
  >
  </gds-heading>
  <gds-spacer classes="spacer-50"></gds-spacer>
  <hr class="hr-rule" />
  <gds-spacer classes="spacer-50"></gds-spacer>
  <gds-heading
    [data]="{
      heading: pageLabels?.['lostForm_conf.lostItem'],
    }"
    class="B1-W4"
  >
  </gds-heading>
  <gds-spacer classes="spacer-50"></gds-spacer>
  <gds-heading
    [data]="{
      heading: lostFoundForm?.value?.selectedLostItemButton,
    }"
    class="A5-W5"
  >
  </gds-heading>
  <gds-spacer classes="spacer-50"></gds-spacer>
  <hr class="hr-rule" />
  <gds-spacer classes="spacer-50"></gds-spacer>
  @for (
    item of lostFoundForm?.value?.subcategories;
    track item;
    let last = $last
  ) {
    <!-- Only display subcategory if it has a selected option -->
    @if (item?.selectedOption?.length > 0) {
      <!-- Subcategory Name -->
      <gds-heading
        [data]="{
          heading: item?.subCategoryName,
        }"
        class="B1-W4"
      >
      </gds-heading>
      <gds-spacer classes="spacer-50"></gds-spacer>
      <!-- Selected Option -->
      <gds-heading
        [data]="{
          heading: item?.selectedOption,
        }"
        class="A5-W5"
      >
      </gds-heading>
      <ng-container>
        <gds-spacer classes="spacer-50"></gds-spacer>
        <hr class="hr-rule" />
        <gds-spacer classes="spacer-50"></gds-spacer>
      </ng-container>
    }
  }
  <gds-heading
    [data]="{
      heading: pageLabels?.['lostForm_conf.lostItem_details'],
    }"
    class="B1-W4"
  >
  </gds-heading>
  <gds-spacer classes="spacer-50"></gds-spacer>
  <gds-heading
    [data]="{
      heading: lostFoundForm?.get('detailLostItem')?.value,
    }"
    class="A5-W5"
  >
  </gds-heading>
  <gds-spacer classes="spacer-50"></gds-spacer>
  <hr class="hr-rule" />
  <gds-spacer classes="spacer-50"></gds-spacer>
  <div class="date-cls">
    <gds-heading
      [data]="{
        heading: pageLabels?.['lostForm_conf.property_return'],
      }"
      class="A5-W4"
    >
    </gds-heading>
  </div>
  <gds-spacer classes="spacer-20"></gds-spacer>

  <gds-heading
    [data]="{
      heading: pageLabels?.['lostForm_conf.property_return_desc'],
    }"
    class="B1-W2"
  >
  </gds-heading>
  <gds-spacer classes="spacer-50"></gds-spacer>
  <gds-heading
    [data]="{
      heading: getSelectedLostPropertyLabel(
        lostFoundForm?.value?.selectedLostPropertyButton
      ),
    }"
    class="A5-W5"
  >
  </gds-heading>
  <gds-spacer classes="spacer-70"></gds-spacer>
  <hr class="hr-rule" />
  <gds-spacer classes="spacer-70"></gds-spacer>
  <!--Lost Found-Confirm CTA -->
  <div class="align-left">
    <gds-buttons
      [data]="{
        type: 'secondary',
        href: '',
        label: pageLabels?.['lostForm_conf.return'],
        disabled: false,
        target: '',
      }"
      (buttonClicked)="lostFoundBackBtn()"
    >
    </gds-buttons>
    <gds-spacer classes="vertical-spacer-50"></gds-spacer>
    <gds-buttons
      [data]="{
        type: 'primary',
        href: '',
        label: pageLabels?.['lostForm_conf.send'],
        target: '',
        disabled: !disableSendBtn && !isSubmitting ? 'false' : 'true',
      }"
      (buttonClicked)="onSubmitLostFoundCreation()"
    >
    </gds-buttons>
  </div>
</div>
